import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WarratyContractAmountVM } from '../../../files-clients/interface/warranty.interface';
import { RegisterWarrantyContractAmountRequest } from '../../interfaces/warranty.interface';
import { WarrantiesService } from '../../../service/warranties.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-warranty-amount-modal',
  templateUrl: './update-warranty-amount-modal.component.html',
  styleUrls: ['./update-warranty-amount-modal.component.scss']
})
export class UpdateWarrantyAmountModalComponent implements OnInit {
  public formGroup: FormGroup;

  constructor(private dialogRef: MatDialogRef<UpdateWarrantyAmountModalComponent>,
    private fb: FormBuilder,
    private warrantiesService: WarrantiesService,
    @Inject(MAT_DIALOG_DATA)public data: WarratyContractAmountVM 
  ){
    this.formGroup = this.fb.group({
      warrantyId:[data.warrantyId],
      contractAmount:[data.contractAmount, [Validators.required, Validators.min(1)]]
    })
  }

  ngOnInit(): void {
      
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }

  submit(){
    const { warrantyId, contractAmount } = this.formGroup.value;
    const request: RegisterWarrantyContractAmountRequest = {
      warrantyId: warrantyId,
      contractAmount: contractAmount
    };

    Swal.fire({
      text: 'Ingresando monto de contrato',
      didOpen: () => {
        Swal.showLoading();
      }
    })
    this.warrantiesService.registerWarrantyContractAmount(request)
    .subscribe({
      next:(res) =>{
        Swal.fire({
          title: 'Operación exitosa',
          text: res.resultMessage,
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((r) => {
          if(r.isConfirmed) {
            this.dialogRef.close(true);
          }
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Operación fallida',
          text: err.error.resultMessage || 'Ha ocurrido un error inesperado',
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        })
      }
    })
  }
  
}
